module.exports = __webpack_public_path__ + "assets/img/mecha-btn-c6d6f993.png";